import React from 'react';
import { BadgesWidget } from './BadgesWidget';
import { ProgressWidget } from './ProgressWidget';
import { CertificatesWidget } from './CertificatesWidget';
import { TeamUserSummary } from '../../types/teamUserSummary';

interface WidgetsProps {
  data: TeamUserSummary;
}

export const Widgets: React.FC<WidgetsProps> = ({ data }) => {
  return (
    <section className="w-full py-2.5">
      <div className="flex flex-col sm:flex-row gap-2 items-stretch">
        <div className="flex-1">
          <ProgressWidget certifications={data.progress} />
        </div>
        <div className="flex-1">
          <BadgesWidget
            count={data.badgeSummary.count}
            trend={data.badgeSummary.trend}
          />
        </div>
        <div className="flex-1">
          <CertificatesWidget 
            certificates={data.certificates} 
            activeCertifications={data.progress}
          />
        </div>
      </div>
    </section>
  );
};
